module.exports = __webpack_public_path__ + "resources/img/img_watchall_apm1_jp.e030b3d7ea6e2154027da28944149729.png";